
import { getSupabase } from './supabase';

const KEY = 'ecc_v24_offline_operations_queue';
const CONFLICTS: Record<string,string> = {
  player_availability:'team_id,player_id,fixture_key',
  player_readiness:'team_id,player_id,entry_date',
  training_attendance:'team_id,player_id,session_date',
  opponent_scouting:'team_id,opponent',
};

type QueueItem = {
  id: string;
  table: string;
  operation: 'upsert' | 'insert' | 'update';
  payload: Record<string, unknown>;
  match?: Record<string, unknown>;
  createdAt: string;
};

function readQueue(): QueueItem[] {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(value) ? value : [];
  } catch { return []; }
}
function writeQueue(items: QueueItem[]) {
  try { localStorage.setItem(KEY, JSON.stringify(items.slice(-250))); } catch {}
}

export function offlineQueueCount() { return readQueue().length; }

export async function resilientWrite(
  table: string,
  operation: QueueItem['operation'],
  payload: Record<string, unknown>,
  match?: Record<string, unknown>,
) {
  if (!navigator.onLine) {
    const q = readQueue();
    q.push({ id: crypto.randomUUID(), table, operation, payload, match, createdAt: new Date().toISOString() });
    writeQueue(q);
    return { ok: true, queued: true };
  }
  try {
    const client = getSupabase();
    let query: any;
    if (operation === 'insert') query = client.from(table).insert(payload);
    else if (operation === 'update') {
      query = client.from(table).update(payload);
      for (const [k,v] of Object.entries(match || {})) query = query.eq(k, v);
    } else query = client.from(table).upsert(payload, CONFLICTS[table] ? { onConflict: CONFLICTS[table] } : undefined);
    const { error } = await query;
    if (error) throw error;
    return { ok: true, queued: false };
  } catch {
    const q = readQueue();
    q.push({ id: crypto.randomUUID(), table, operation, payload, match, createdAt: new Date().toISOString() });
    writeQueue(q);
    return { ok: true, queued: true };
  }
}

export async function flushOperationsQueue() {
  if (!navigator.onLine) return 0;
  const items = readQueue();
  if (!items.length) return 0;
  const client = getSupabase();
  const remaining: QueueItem[] = [];
  let done = 0;
  for (const item of items) {
    try {
      let query: any;
      if (item.operation === 'insert') query = client.from(item.table).insert(item.payload);
      else if (item.operation === 'update') {
        query = client.from(item.table).update(item.payload);
        for (const [k,v] of Object.entries(item.match || {})) query = query.eq(k, v);
      } else query = client.from(item.table).upsert(item.payload, CONFLICTS[item.table] ? { onConflict: CONFLICTS[item.table] } : undefined);
      const { error } = await query;
      if (error) throw error;
      done += 1;
    } catch { remaining.push(item); }
  }
  writeQueue(remaining);
  return done;
}
